import React from 'react'
import * as UI from 'ui'
import { SpaceBetween } from 'ui'
import * as Displays from 'support/displays'
import { Translation, Translator } from '@morningtrain/react-translations'
import Widget from 'widgets/Widget'
import {ForEachModel, Model, ValueToCollection} from '@morningtrain/react-resources'
import { SelectedDepartmentFilter } from 'support/filters'
import { Can } from '@morningtrain/react-auth'
import SmartviewTextGroup from 'widgets/smartviews/partials/SmartviewTextGroup'
import SmartviewContentSeparator from 'widgets/smartviews/partials/SmartviewContentSeparator'
import SmartviewText from 'widgets/smartviews/partials/SmartviewText'
import CardSummarySection from 'widgets/economy/partials/CardSummarySection'
import { Link } from '@morningtrain/react-navigation'
import CookieFilter from "support/filters/CookieFilter";
import RevenueTable from "pages/app/economy/partials/RevenueTable";
import {Env} from "@morningtrain/helpers";

export default function TotalRevenueEconomyWidget ({ className, linkToDetails = true, ...otherProps }) {
  const outOfSection = (children, props) => (
    <UI.Text size='xs' block className='w-full' {...props}>
      <Translation name="generic.budget"/>
      <span>: </span>
      {children}
    </UI.Text>
  )

  const hasMultipleTakeaway = Env.get('globals.has_multiple_takeaway');

  return (
    <Can permission='api.economy.total_revenue'>
      <Widget>
        <Translator namespace='economy.total_revenue'>
          <UI.Card paddingBottom={false} className={className}>
            <SpaceBetween>
              <UI.Text weight='medium' size='lg'>
                <Translation name='title' />
              </UI.Text>
              {linkToDetails === true
                ? (
                  <Link route='app.economy.revenue' disableRouting>
                    <UI.Button color='lightgray'>
                      <Translation name='view_all' />
                    </UI.Button>
                  </Link>
                  )
                : null}
            </SpaceBetween>

            <Model resourceName='economy' operationName='total_revenue'>
              <CookieFilter name='period' cookieKey='page.filters.period' />
              <SelectedDepartmentFilter />

              <div className='flex flex-col flex-grow flex-shrink pt-6'>

                <UI.WithSubtitle subtitle={outOfSection(<Displays.Currency name='budget_this_period' decimals={0} />)}>
                  <UI.Text weight='medium' size='3xl'>
                    <Displays.Currency name='revenue' decimals={0} />
                  </UI.Text>
                </UI.WithSubtitle>

                <SmartviewContentSeparator />

                <SmartviewTextGroup highlight highlightSize='card'>

                  <SmartviewText>
                    <UI.SpaceBetween>
                      <UI.Text size='base'>
                        <Translation name='departments.inhouse' />
                      </UI.Text>

                      <UI.Text weight='medium' size='base' align='right' color='black'>
                        <Displays.Currency name='revenue_inhouse' decimals={0} />
                      </UI.Text>

                    </UI.SpaceBetween>
                  </SmartviewText>

                {!hasMultipleTakeaway ?
                  <SmartviewText>
                    <UI.SpaceBetween>
                      <UI.Text size='base'>
                        <Translation name='departments.takeaway' />
                      </UI.Text>

                      <UI.Text weight='medium' size='base' align='right' color='black'>
                        <Displays.Currency name='revenue_takeaway' decimals={0} />
                      </UI.Text>

                    </UI.SpaceBetween>
                  </SmartviewText> : false
                }
                  {hasMultipleTakeaway ?
                    <ValueToCollection name='revenue_takeaways'>
                    <ForEachModel>
                      <SmartviewText>
                        <UI.SpaceBetween>
                          <UI.Text size='base'>
                            <Displays.Text name='name' />
                          </UI.Text>

                          <UI.Text weight='medium' size='base' align='right' color='black'>
                            <Displays.Currency name='total_revenue' decimals={0} />
                          </UI.Text>

                        </UI.SpaceBetween>
                      </SmartviewText>
                    </ForEachModel>
                  </ValueToCollection> : false }

                </SmartviewTextGroup>

              </div>

              <UI.HorizontalList border className='my-4 pt-6 -mx-8'>
                <CardSummarySection />
              </UI.HorizontalList>

            </Model>

          </UI.Card>
        </Translator>
      </Widget>
    </Can>
  )
}
